// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BAZAAR_PRODUCT_COMPLAINT_TITLE = "Nahla\u0161uji inzer\u00e1t, kter\u00fd poru\u0161uje pravidla - https://www.modrykonik.cz/jine/pravidla-bazaru/";
export const FORUM_COMMENT_DOES_NOT_BELONG_TO_FORUM = "Nahla\u0161uji nevhodnou odpov\u011b\u010f";
export const IMAGE_DOES_NOT_BELONG_TO_PHOTOBLOG = "Nahl\u00e1sit obr\u00e1zek";
export const MESSAGE_DOES_NOT_BELONG_TO_FORUM = "Nahla\u0161uji nevhodn\u00fd p\u0159\u00edsp\u011bvek";
export const PHOTOBLOG_COMMENT_DOES_NOT_BELONG_TO_PHOTOBLOG = "Nahla\u0161uji nevhodn\u00fd koment\u00e1\u0159";
export const PHOTOBLOG_POST_DOES_NOT_BELONG_TO_PHOTOBLOG = "Nahla\u0161uji nevhodn\u00fd p\u0159\u00edsp\u011bvek";
